import React from 'react';
import Radio from '~/components/Radio';
import themeVariables from '~/shared/themeVariables';

const Index = (props) => {
  const { label, checked, onChange, data } = props;
  return (
    <div
      className={`button-select-container ${checked ? 'active ' : 'unactive'}`}
    >
      <div className="radio-container">
        <Radio
          checked={checked}
          groupName="select"
          label={label}
          onChange={() => onChange(data)}
        />
      </div>
      <style jsx>
        {`
          .button-select-container {
            width: 110px;
            height: 48px;
            left: 466.5px;
            top: 0px;
            border: 1px solid #7a7a7a;
            box-sizing: border-box;
            border-radius: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000000;
          }
          .active {
            background: ${themeVariables.colors.primary};
            color: #ffffff;
          }
        `}
      </style>
      <style jsx global>
        {`
          .button-select-container.active .radio-container .ac-radio > label {
            color: #ffffff;
          }
          .button-select-container.unactive .radio-container .ac-radio > label {
            color: #000000;
          }
        `}
      </style>
    </div>
  );
};
export default Index;
